import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { bl_fi_generic_doc_hdr_RowClass, PrintableFormatContainerModel, BranchDefaultPrintableFormatHdrService, Pagination, DocumentShortCodesClass } from 'blg-akaun-ts-lib';
import { SessionSelectors } from '../../modules/session/session-controller/selectors';
import { SessionStates } from '../../modules/session/session-controller/states';
import { AppConfig } from '../../visa';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink2';
import { PrintService } from '../../services/print-service';
import { ToastrService } from "ngx-toastr";
import {
  catchError,
  tap,
  map,
  switchMap,
  filter
} from "rxjs/operators";
import { DocTypeHandlers } from '../../models/doc-type-handler';


@Component({
  selector: 'app-util-generic-document-view-export',
  templateUrl: './generic-document-view-export.component.html',
  styleUrls: ['./generic-document-view-export.component.scss']
})
export class GenericDocumentViewExportComponent implements OnInit {
  @Input() genericDoc$: Observable<any>;
  protected subs = new SubSink();

  @Input() draft$: Observable<bl_fi_generic_doc_hdr_RowClass>;
  @Output() print = new EventEmitter();

  readonly appletSettings$ = this.sessionStore.select(SessionSelectors.selectMasterSettings);

  apiVisa = AppConfig.apiVisa;
  printableFormat = new FormControl();
  docHdr;
  txn_type;

  constructor(
    private toastr: ToastrService,
    private printService: PrintService,
    private branchPrintableService: BranchDefaultPrintableFormatHdrService,
    private readonly sessionStore: Store<SessionStates>
  ) {}

  ngOnInit() {
    this.subs.sink = this.genericDoc$.pipe(
      tap((resolve) => {
        this.docHdr = resolve?.bl_fi_generic_doc_hdr;
        this.txn_type =  resolve?.bl_fi_generic_doc_hdr?.server_doc_type;
      }),
      filter(() => this.docHdr?.server_doc_type && this.docHdr?.guid_branch),
      switchMap(() => {
        const paging = this.createPagination(this.docHdr.guid_branch, this.docHdr.server_doc_type);
        return this.branchPrintableService.getByCriteria(paging, this.apiVisa);
      }),
      map((res) => {
        const printable = res.data.length
          ? res.data[0].bl_fi_mst_branch_default_printable_format_hdr
              ?.default_printable_format_guid
          : null;
        return printable;
      })
    ).subscribe({
      next: (printable) => this.printableFormat.setValue(printable),
      error: (err) => console.error("Error fetching printable format:", err),
    });
  }

  private createPagination(branchGuid: string, txnType: string): Pagination {
    const paging = new Pagination();
    paging.conditionalCriteria = [
      { columnName: "branch_guid", operator: "=", value: branchGuid },
      { columnName: "server_doc_type", operator: "=", value: txnType },
    ];
    return paging;
  }

  onPrintableFormatChange(e: PrintableFormatContainerModel) {
    this.printableFormat.setValue(e.bl_prt_printable_format_hdr.guid.toString());
  };

  onPrint() {
    let docShortCode = DocumentShortCodesClass.serverDocTypeToShortCodeMapper(this.docHdr.server_doc_type?.toString());
    const docURL = DocTypeHandlers.getDocURL(this.txn_type);

    this.printService.printJasperPdf(
      docURL,
      this.docHdr.guid,
      'GENERICE_DOCUMENT_JASPER_PRINT_SERVICE',
      this.printableFormat.value,
      AppConfig.apiVisa
    ).pipe(
      tap((a) => {
        const downloadURL = window.URL.createObjectURL(a);
        const link = document.createElement("a");
        link.href = downloadURL;
        link.download = `${docShortCode}-${this.docHdr.server_doc_1}.pdf`;
        link.click();
        link.remove();
        this.toastr.success(
          "Document Exported Successfully",
          "Success",
          {
            tapToDismiss: true,
            progressBar: true,
            timeOut: 2000,
          }
        );
      }),
      catchError((err) => {
        throw err;
      })
    ).subscribe({
      error: (err) => console.error("Error while printing:", err),
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }


}
